<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="close-button" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<h2 mat-mdc-dialog-title *ngIf="data.newType">{{ 'T4.Service.ServiceGuyTypeDialog.lblHeadline' | translate : 'New Type'}}</h2>
<h2 mat-mdc-dialog-title *ngIf="data.type">Type : {{ data.type.Name }}</h2>

<t4-container>
  <mat-dialog-content>

    <mat-tab-group>
      <mat-tab label="{{'T4.Service.ServiceGuyTypeDialog.tblGeneral' | translate : 'General' }}">
        <form [formGroup]="form">
          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyTypeDialog.txtName' | translate : 'Name'}}</mat-label>
            <input id="txtName"
                   autocomplete="off"
                   matInput
                   formControlName="name"
                   [(ngModel)]="type.Name">
            <mat-error>{{ 'T4.Service.ServiceGuyTypeDialog.txtName_required' | translate : 'A name is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-12">
            <mat-label>{{ 'T4.Service.ServiceGuyTypeDialog.txtDescription' | translate : 'Description'}}</mat-label>
            <textarea id="txtDescription"
                   autocomplete="off"
                   matInput
                   formControlName="description"
                   rows="5"
                      [(ngModel)]="type.Description">
            </textarea>
            <mat-error>{{ 'T4.Service.ServiceGuyTypeDialog.txtDescription_required' | translate : 'A Description is required'}}</mat-error>
          </mat-form-field>
        </form>
      </mat-tab>

      <ng-container *ngIf="data.type">
        <mat-tab label="{{'T4.Service.ServiceGuyTypeDialog.tblStockSettings' | translate : 'Stock Settings' }}">

          <t4-data-table #tblInStock [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="stockSettings" headline="{{'T4.Service.ServiceGuyTypeDialog.lblStockSettings' | translate : 'Stock Settings' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false">

            <ng-container matColumnDef="ItemName">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{'T4.Service.ServiceGuyTypeDialog.lblItemName' |translate : 'Item Name' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Item.Name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Id">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{'T4.Service.ServiceGuyTypeDialog.lblIdentifier' |translate : 'Article Id' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.ItemId }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="MinLevel">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px; max-width:120px">{{'T4.Service.ServiceGuyTypeDialog.lblMinLevel' | translate : 'Min Level' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;  max-width:120px; justify-content: center;"><input min="0" matInput appearance="outline" type="number" placeholder="row.MinLevel" (ngModelChange)="onValueChange(row)" [(ngModel)]="row.MinLevel"  style="max-width:60px"></mat-cell>
            </ng-container>

            <ng-container matColumnDef="RecommendedLevel"> 
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px; max-width:120px">{{'T4.Service.ServiceGuyTypeDialogRecommendedLvl' |translate : 'Recommended' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px; max-width:120px; justify-content: center;"><input min="0" matInput appearance="outline" type="number" placeholder="row.RecommendedLevel" (ngModelChange)="onValueChange(row)" [(ngModel)]="row.RecommendedLevel" style="max-width:60px"></mat-cell>
            </ng-container>

          </t4-data-table>
        </mat-tab>
      </ng-container>
     </mat-tab-group>

  </mat-dialog-content>
</t4-container>

<mat-dialog-actions>
  <div class="col-6" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button [disabled]="disabled" mat-flat-button color="primary" style="margin: 3px;" (click)="save()">
      {{'T4.Service.ServiceGuyTypeDialog.cmdConfirm' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
